// extracted by mini-css-extract-plugin
module.exports = {"root":"alcoholic-beverage-disposal-page_root__nuOAj"};